import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";

export default function GoogleLoginButton({ onSuccess }) {
  return (
    <GoogleLogin
      onSuccess={async (response) => {
        console.log(response?.credential);
        const idToken = response?.credential; // <-- ID token (JWT)
        if (!idToken) throw new Error("Missing Google id_token");
        try {
          const { data } = await axios.post(
            //"http://localhost/leads-backoffice/wp-json/custom-auth/v1/google",
            "https://crm-backoffice.connvisor.com/wp-json/custom-auth/v1/google",
            { idToken },
            { headers: { "Content-Type": "application/json" } }
          );
          onSuccess?.(data);
        } catch {
          console.log("Login failed");
        }
      }}
      onError={() => console.error("Google login failed")}
      useOneTap={false} // set true if you want One Tap
    />
  );
}
